import styled from "styled-components";

export const Container = styled.div`
  width: 90%;
  padding-top: 10px;
  padding-bottom: 10px;
  display: grid;
  grid-template-columns: 120px auto;
  grid-template-areas:
    "header header"
    "image-area text-area";
  grid-template-rows: 30px 120px;
  row-gap: 5px; // header와 image,textbox 사이 간격

  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
`;

export const Image = styled.img`
  grid-area: image-area;
  height: 120px;
`;

export const TextBox = styled.div`
  grid-area: text-area;
  display: flex;
  flex-direction: column;
  padding-top: 5px;
  padding-left: 10px;
  gap: 7px;
`;

export const Header = styled.div`
  grid-area: header;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const DataSet = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  @media ${({ theme }) => theme.device.tablet} {
    gap: 10px;
  }
`;
